// extracted by mini-css-extract-plugin
module.exports = {"video":"webinar_video__1fk-x","container":"webinar_container__kLLvd","root":"webinar_root__YltSR","bar":"webinar_bar__cLsbb"};